var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllStaff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3977 12.5C14.239 11.7937 15.4089 11.3026 17.0361 11.3026C21.3324 11.3026 22.4415 14.7268 22.7278 16.4947C22.8194 17.0602 22.356 17.5244 21.7745 17.5244H19",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3417 12.5C10.5004 11.7937 9.33044 11.3026 7.7033 11.3026C3.40696 11.3026 2.29786 14.7268 2.01156 16.4947C1.91995 17.0602 2.38336 17.5244 2.96492 17.5244H5.73938",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3697 10.2218C14.0878 10.2218 15.4806 8.82902 15.4806 7.11091C15.4806 5.3928 14.0878 4 12.3697 4C10.6516 4 9.25879 5.3928 9.25879 7.11091C9.25879 8.82902 10.6516 10.2218 12.3697 10.2218Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2163 5.52803C15.6045 5.20236 16.0806 4.99914 16.5841 4.94394C17.0878 4.8888 17.5965 4.98424 18.0459 5.21819C18.4952 5.4521 18.8652 5.81408 19.1089 6.25828C19.3526 6.70247 19.4591 7.20897 19.415 7.7137C19.3708 8.21839 19.1779 8.69869 18.8609 9.09385C18.5437 9.48895 18.1165 9.78115 17.6333 9.93352C17.1501 10.0859 16.6326 10.0915 16.1462 9.94975C15.6598 9.80798 15.2264 9.52516 14.9007 9.13703",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52303 5.52803C9.13489 5.20237 8.65888 4.99912 8.15524 4.94395C7.6516 4.8888 7.14291 4.98423 6.69351 5.21817C6.2441 5.45212 5.87416 5.81408 5.63046 6.25827C5.38677 6.70247 5.28027 7.20896 5.32442 7.71367C5.36858 8.21841 5.56142 8.6987 5.87854 9.09383C6.19567 9.48896 6.62284 9.78117 7.10605 9.93353C7.58925 10.0859 8.10678 10.0915 8.59318 9.94976C9.0796 9.80798 9.51304 9.52515 9.83871 9.13703",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3697 12.696C17.3941 12.696 18.6911 16.7623 19.0259 18.8616C19.1331 19.5332 18.5911 20.0844 17.911 20.0844H6.82841C6.14832 20.0844 5.6064 19.5332 5.71351 18.8616C6.0483 16.7623 7.3453 12.696 12.3697 12.696Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStaff);
export default __webpack_public_path__ + "static/media/AllStaff.293e9bbf6b700e95f412f0a9c60b510a.svg";
export { ForwardRef as ReactComponent };